import { Component, Input } from '@angular/core';

@Component({
  selector: 'mk-sliding-bar',
  template: `<div class="sliding-bar" [style.background-color]="colorOne"><div [style.background-color]="colorTwo"></div></div>`,
  styles: [`.sliding-bar{height:4px;width:100%;position:relative;overflow:hidden}.sliding-bar>div{display:block;position:absolute;content:"";left:-200px;width:200px;height:4px;background-color:#2980b9;-webkit-animation:2s linear infinite loading;animation:2s linear infinite loading}@-webkit-keyframes loading{from{left:-200px;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}@keyframes loading{from{left:-200px;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}`]
})
export class SlidingBarComponent {
  @Input() colorOne = '#ddd';
  @Input() colorTwo = '#3c8dbc';
}
